export const listKeys = {
  all: ['lists'] as const,
  lists: () => [...listKeys.all, 'list'] as const,
  detail: (id: string) => [...listKeys.all, 'detail', id] as const,
  trainingStats: () => [...listKeys.all, 'ocr', 'training-stats'] as const,
};
